<script setup lang="ts">
  import * as uiLocales from '@nuxt/ui/locale'

  // Idioma
  const { locale } = useI18n()

  // Obtener el locale de Nuxt UI según el locale de i18n
  const uiLocale = computed(() => {
    const localeMap: Record<string, any> = {
      'es': uiLocales.es,
      'en': uiLocales.en,
      'de': uiLocales.de,
      'it': uiLocales.it,
      'fr': uiLocales.fr
    }
    return localeMap[locale.value] || uiLocales.es
  })

  // Iniciar dia
  const selectedDiaStore = useSelectedDayStore()
  selectedDiaStore.init()

  // Iniciar Suggested Destinations
  const suggestedDestinations: Ref<StrapiDestination[]> = useState('suggested-destinations')
  await callOnce(async () => {
    suggestedDestinations.value = await getStrapiData('suggested-destinations', {
      locale: locale.value
    }) as StrapiDestination[]
    suggestedDestinations.value.sort((a: StrapiDestination, b: StrapiDestination) => a.order - b.order)
  })

  // Iniciar Monedas (estado global)
  const currencies: Ref<Currency[]> = useState('currencies')
  await callOnce(async () => {
    try {
      const response = await $fetch<{ data: Currency[] }>(`${useBaseUrl()}/currencies`, {
        headers: { 'Content-Type': 'application/json' },
        query: { locale: locale.value }
      })
      currencies.value = response?.data || []
    } catch (error) {
      try {
        const response = await $fetch<Currency[]>('/api-web/currencies', {
          headers: { 'Content-Type': 'application/json' }
        })
        currencies.value = response as Currency[] || []
      } catch (error) {
        console.error('Error fetching currencies:', error)
      }
    }
  })

  // Head
  useHead({
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
      }
    ],
    link: [
      {
        rel: 'icon',
        href: '/favicon.ico'
      },
      {
        rel: 'preload',
        href: '/fonts/NHaasGroteskText.woff2',
        as: 'font',
        type: 'font/woff2',
        crossorigin: ''
      },
      {
        rel: 'preload',
        href: '/fonts/NHaasGroteskDisplay-bold.woff2',
        as: 'font',
        type: 'font/woff2',
        crossorigin: ''
      }
    ]
  })
</script>

<template>
  <UApp :locale="uiLocale">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>